import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
    faArrowRightArrowLeft,
    faArrowRightFromBracket,
    faArrowRightToBracket,
} from '@fortawesome/free-solid-svg-icons';

import {
    CameraDirectionDisplay,
    formatCameraDirectionLabel,
    resolveCameraDirectionDisplay,
} from './camera-direction.helpers';

@Component({
    selector: 'app-camera-direction-indicator',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './camera-direction-indicator.component.html',
    styleUrl: './camera-direction-indicator.component.css',
})
export class CameraDirectionIndicatorComponent {
    /** Raw Camera.direction API value (ENTRY | EXIT | BIDIRECTIONAL). */
    @Input() direction: string | null | undefined;

    constructor(library: FaIconLibrary) {
        library.addIcons(faArrowRightToBracket, faArrowRightFromBracket, faArrowRightArrowLeft);
    }

    get display(): CameraDirectionDisplay | null {
        return resolveCameraDirectionDisplay(this.direction);
    }

    get fallbackLabel(): string {
        return formatCameraDirectionLabel(this.direction);
    }
}
